// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.7.12_webpack@5.111.1_clean-css@5.3.3_cssnano@6.1.2_pos_f7609ee3c1acb66cd8150375f18aa5d7/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.7.12_webpack@5.111.1_clean-css@5.3.3_cssnano@6.1.2_pos_f7609ee3c1acb66cd8150375f18aa5d7/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#app-root {
  height: 100%;
}
.root-layout {
  height: 100%;
}
.ant-layout.page-layout {
  position: relative;
  overflow: auto;
}
.ant-layout-content.page-content {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
.ant-layout-content.page-content .ant-table-wrapper {
  margin: 0 24px 24px 24px;
}
.ant-layout-content.page-content .ant-table-export-btn-wrapper {
  margin: 0 24px 24px 24px;
  text-align: right;
}
.ant-layout-header.page-header {
  background: transparent;
  padding: 0 24px;
  display: flex;
  align-items: center;
  height: 80px;
}
.ant-layout-header.page-header > .ant-row {
  width: 100%;
}
.ant-layout-content.page-content {
  flex-shrink: 0;
}
.ant-layout-content.page-content .ant-table-wrapper {
  margin: 0 24px 24px 24px;
}
.ant-layout-content.app-content {
  flex-shrink: 0;
}
.ant-breadcrumb-link > a > .anticon + span {
  margin-left: 4px;
}
.ant-message {
  margin-top: 64px !important;
}
.section {
  background: #fff;
}
.alert-section {
  width: calc(100% - 48px);
  margin: 0 24px 24px 24px;
}
@media (min-width: 0px) {
  .section.left {
    margin: 0 24px 24px 24px;
    width: calc(100% - 48px);
  }
  .section.right {
    margin: 0 24px 24px 24px;
    width: calc(100% - 48px);
  }
  .section.middle {
    margin: 0 24px 24px 24px;
    width: calc(100% - 48px);
  }
}
@media (min-width: 992px) {
  .section.left {
    margin-right: 12px;
    width: calc(100% - 36px);
  }
  .section.right {
    margin-left: 12px;
    width: calc(100% - 36px);
  }
  .section.middle {
    margin-left: 12px;
    width: calc(100% - 24px);
  }
}
.section-header {
  display: flex;
  align-items: center;
  font-size: 18px;
  height: 32px;
  line-height: 32px;
  margin-bottom: 24px;
}
.app-root {
  min-height: 100vh;
}
.ant-modal-wrap.expanded-image-modal-wrap {
  position: absolute;
}
.ant-modal-wrap.expanded-image-modal-wrap .ant-modal-close {
  margin: 15px;
  background-color: rgba(0, 0, 0, 0.45);
  color: rgba(255, 255, 255, 0.45);
  transition: all 0.2s linear;
}
.ant-modal-wrap.expanded-image-modal-wrap .ant-modal-close:hover,
.ant-modal-wrap.expanded-image-modal-wrap .ant-modal-close:focus {
  background-color: rgba(0, 0, 0, 0.75);
  color: rgba(255, 255, 255, 0.75);
}
.ant-modal-wrap.expanded-image-modal-wrap img {
  width: 100%;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
